const Images = {
  logo: require("./logo.png"),
  navlogo: require("./navlogo.png"),
  calender: require("./calender.png"),
  carosel1: require("./1.jpg"),
  carosel2: require("./2.jpg"),
  carosel3: require("./3.jpg"),
  title_border: require("./title-border.png"),
  achieve: require("./achieve.jpg"),
  newsplane: require("./news-plane.jpg"),
  largead: require("./large-ad.jpg"),
  sidead: require("./side-add.jpg"),
  newsgrid: require("./news-grid.jpg"),
  trending_img: require("./trending-img.jpg"),
  jail: require("./jail.jpg"),
  girl: require("./girl.jpg"),
  news_plane: require("./news-plane.jpg"),
  user_img: require("./user-img.jpg"),
  calender1: require("./calender/Table1.jpg"),
  calender2: require("./calender/Table2.jpg"),
  calender3: require("./calender/Table3.jpg"),
  calender4: require("./calender/Table4.jpg"),
  calender5: require("./calender/Table5.jpg"),
  calender6: require("./calender/Table6.jpg"),
  calender7: require("./calender/Table7.jpg"),
  calender8: require("./calender/Table8.jpg"),
  qr: require("./qr.png"),
  kyc: require("./kyc-gif.gif"),
  pay_now: require("./pay-now.gif"),
  share: require("./share.png"),
  neta: require("./neta.jpeg"),
  plusIcon: require("./plusIcon.svg").default,
  minusIcon: require("./minusIcon.svg").default,
  folderOpenIcon: require("./folderOpenIcon.svg").default,
  folderCloseIcon: require("./folderCloseIcon.svg").default,
  fileIcon: require("./file.svg").default,
  eyeOpen: require("./eye-open.svg").default,
  eyeClose: require("./eye-close.svg").default,
  new: require("./new.gif"),
  heading: require("./heading.gif"),
  btn_loading: require("./btn-loading.svg").default,
  row_add: require("./row-add-icon.svg").default,
  row_minus: require("./row-minus-icon.svg").default,
  skip_ads: require("./skip-ad.jpg"),
  defaultImg : require("./user.png")
};

export default Images;
